
import React, { useEffect, useState } from 'react';
import { useSetState } from 'Utils/Helpers/Hooks';
import Inputer from 'Utils/Helpers/Inputer';
import { TextShow } from 'Utils/Helpers/TextShow';
import { useSelector, useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CButton from 'Utils/Helpers/CButton';
import Box from '../Box';
import { enqueueSnackbar } from 'notistack';
import { createType, getTypes } from 'http/components/SettingService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetSystemTypes, SetUsersData } from 'Utils/Helpers/HandleApiData';

export default function NewType() {
  const dispatch = useDispatch();
  const { total } = useSelector((state) => ({
    total: state.staff.total,
  }));
  const [reset, setReset] = useState(false);
  const [selected, setSelected] = useState([]);
  const [controls, setControls] = useSetState ({
    name: {
      id: "name",
      type: 'text',
      placeholder: 'عنوان',
      value: '',
      icon: <icons.Type/>,
    },
    color: {
      id: "color",
      type: 'color',
      placeholder: 'رنگ',
      value: '#52718a',
      icon: <icons.PaletteFill/>,
    },
  });
  
  const setControlsValue = (name, value) => {
    setControls({ [name]: { value: value } });
  }

  useEffect(() => {
    if(reset) {
      if(selected.length !== 1) {
        setSelected(selected.map(items => {
          items.status = false;
          return items;
        }))
      }
      setControls({ name: { value: '' } });
      setControls({ color: { value: '#52718a' } });
      setReset(false);
    }
  }, [reset])

  useEffect(() => {
    if(total && !reset) {
      let docs = [];
      let preStatus = false;
      if(total.filter(items => items.doctor).length === 1) preStatus = true;
      total.filter(items => items.doctor).map(items => {
        docs.push({
          id: items.id,
          name: items.name,
          status: preStatus,
        })
      })
      setSelected(docs)
    }
  }, [total, reset])

  const handleChangeSelected = (event) => {
    setSelected(selected.map(items => {
      if(items.id === event.target.name)
        items.status = event.target.checked;
      return items;
    }))
  }

  const onCreateType = async () => {
    dispatch(HandleLoading(true));
    const {name, color} = controls;
    const drs = selected.filter(i => i.status).map(i => i.id);
    if(name.value !== '' && color.value !== '' && drs.length !== 0) {
      const response = await createType(name.value, color.value, drs);
      if(response.status) {
        const response2 = await getTypes();
        if(response2.status) {
            await dispatch(SetUsersData(response2.data.users));
            await dispatch(SetSystemTypes(response2.data));
            setReset(true);
            enqueueSnackbar('نوع با موفقیت اضافه شد', {variant: 'success'});
        } else {
          dispatch(HandleLoading(false));
        }
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      enqueueSnackbar('اطلاعات به درستی وارد نشده است', {variant: 'error'});
      dispatch(HandleLoading(false));
    }
  }
  
  return (
    <Box
      title={"ثبت نوع جدید"}
      info={"منظور از نوع همان خدمات مطب (مانند ویزیت) می‌باشد"}
      body={
        <>
          <div className='w-100 flex-column-start-start mb-2'>
            {
              !reset && Object.keys(controls).map((key, index) => {
                return (
                  <>
                    <small className='pe-1 mb-1'>{controls[key].placeholder}</small>
                    <Inputer
                      key={`inputer_${controls[key].id}`}
                      id={controls[key].id}
                      type={controls[key].type}
                      value={controls[key].value}
                      setValue={setControlsValue.bind(this)}
                      icon={controls[key].icon}
                      className={'mb-1'}
                    />
                  </>
                )
              })
            }
          </div>
          {
            !reset && (selected.length !== 0 && selected.length !== 1) &&
            <>
              <TextShow
                title={"انتخاب پزشک :"}
                justText
                className={'no-hide text-muted me-1'}
              />
              <div className='w-100 group-checkbox'>
                {
                  selected.map((items, index) => {
                    return (
                      <div className='times-checkbox doctor-show'>
                        <FormControlLabel
                          key={`fcs-${index}`}
                          control={<Checkbox
                            name={items.id}
                            sx={{margin: 0, padding: 0, marginLeft: '3px'}}
                            checked={items.status}
                            onChange={handleChangeSelected}
                          />}
                          label={items.name}
                        />
                      </div>
                    )
                  })
                }
              </div>
            </>
          }
          <CButton
            text={'ذخیره نوع جدید'}
            icon={<icons.Save2/>}
            className={'my-3'}
            onClick={onCreateType}
          />
        </>
      }
    />
  );
}